
export enum PageContentType {
    FRONTPAGE = 'FRONTPAGE',
    BROKER = 'BROKER',
    CONTACT = 'CONTACT',
    SERVICE = 'SERVICE',
    CUSTOMER = 'CUSTOMER',
    NEWS = 'NEWS',
    BUY = 'BUY',
    HOME = 'HOME',
    FORSALE = 'FORSALE'
}

export enum ImageType {
    Default = 'default',
    Logo = 'logo'
}

export enum ArticleType {
    NEWS = 'NYHETER',
    SERVICES = 'TJENESTER',
    CUSTOMERS = 'CUSTOMERS'
}